// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-messages-error',
    mixins: [appHost.mixins.modal],
    // #endregion
    // #region Properties
    props: {
        title: {
            type: String,
            required: false
        },
        message: {
            type: String,
            required: false
        },
        closeCallback: {
            type: Function,
            required: false
        },
    },
    // #endregion
    // #region Core
    computed: {
        hasTitle() {
            return !utils.isNullOrEmpty(this.title);
        }
    },
    // #endregion
    // #region Methods
    methods: {
        onClose() {
            // #region Callback
            if (this.closeCallback) {
                Promise.resolve(this.closeCallback())
                    .then(() => this.close(1))
                    .catch((e) => {
                    let tResult = {
                        state: 3,
                        error: utils.getAxiosError(e)
                    };
                    this.close(tResult);
                });
            }
            // #endregion
            // #region Close
            else {
                this.close(1);
            }
            // #endregion
        },
    }
    // #endregion
});
// #endregion
